<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="prefix + title">
        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row>
                        <b-col cols="12" sm="6">
                            <lg-finder-page-pessoa id="finderPessoaBaixaItemBemConsumoList" label="Responsável:*"
                                :prefix="prefix + title + ' > '" title="Responsáveis" v-model="form.responsavel"
                                invalidFeedback="Informe um responsável!" :disabled="isVisualizar"
                                @onselect="handlePessoaSelect" />
                        </b-col>
                        <b-col cols="12" sm="6">
                            <lg-form-date label="Data:*" v-model="form.data" description="" :disabled="isVisualizar"
                                invalidFeedback="Data obrigatória!" />
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-2">
                        <b-col cols="12" sm="6">
                            <LgFinderPageTipoBaixa id="finderTipoBaixa" @input="handleTipoBaixaSelect"
                                label="Tipo de Baixa:*" v-model="form.tipoBaixa" :prefix="[prefix + title]"
                                :disabled="isVisualizar" :isModal="true" />
                        </b-col>
                        <b-col cols="12" sm="6">
                            <lg-form-input :disabled="isVisualizar" invalidFeedback="Informe uma hora!" description=" "
                                v-model="form.horaEntrada" label="Hora:*" md="4" sm="4" cols="12"
                                @input="formatarHoraEntrada" @keypress.native="onlyNumbers" maxlength="5"
                                inputmode="numeric" pattern="[0-9]*" />
                        </b-col>
                    </b-form-row>
                    <b-form-row class="mt-2">
                        <b-col cols="12" sm="6" class="d-flex justify-content-start">
                            <b-form-checkbox v-model="motivoGeralChecked" class="mr-2" :disabled="isVisualizar"
                                @change="handleMotivoGeral">
                                Motivo Geral
                            </b-form-checkbox>
                            <lg-form-textarea v-if="motivoGeralChecked" description=" " label="Observação:" cols="12"
                                :disabled="isVisualizar" v-model="form.motivoGeral" />
                        </b-col>
                    </b-form-row>
                </b-card>
                <div class="d-flex justify-content-end mt-3">
                    <b-button id="novo" class="mb-2 mr-2" size="sm" pill variant="secondary" :disabled="isVisualizar"
                        @click="showModalAlmoxarifadoItem">
                        <div class="btn-size-alinhamento">
                            <b-icon scale="1" icon="plus" />
                        </div>
                        <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                    </b-button>
                </div>
                <b-card bg-variant="light" class="mt-3">
                    <div style="overflow-x: auto; overflow-y: auto; max-height: 400px;">
                        <b-table responsive small :items="filteredItems" :fields="tableFields" :hover="true"
                            :busy="this.busy" show-empty>
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong> Carregando...</strong>
                                </div>
                            </template>

                            <template #cell(numero)="row">
                                {{ row.item.numero }}
                            </template>
                            <template #cell(produto)="row">
                                {{ row.item.produto }}
                            </template>
                            <template #cell(almoxarifado)="row">
                                {{ row.item.almoxarifado }}
                            </template>
                            <template #cell(lote)="row">
                                {{ row.item.lote }}
                            </template>
                            <template #cell(motivoEspecifico)="row">
                                <lg-form-input class="mt-3" v-if="!isVisualizar" v-model="row.item.motivoEspecifico" />

                                <span v-if="isVisualizar">{{ row.item.motivoEspecifico }}</span>
                            </template>
                            <template #cell(quantidade)="row">
                                <lg-form-input class="mt-3" :disabled="isVisualizar" type="number"
                                    v-model="row.item.quantidade" />
                            </template>
                            <template #cell(status)="row">
                                {{ row.item.status }}
                            </template>
                            <template v-slot:cell(estornar)="row">
                                <b-button v-if="row.item.status === 'Baixado'" :id="row.index + 'estornar-button'"
                                    class="my-2" size="sm" pill variant="primary"
                                    @click="estornarIndividualmente(row.item)">
                                    <b-icon icon="arrow-left" />
                                    <b-tooltip :target="row.index + 'estornar-button'" title="Estornar..."></b-tooltip>
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-card>
            </b-card-body>
        </b-card>
        <b-form-row class="mt-2">
            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
                <b-button id="salvarBaixaItemBemConsumo" class="my-2" size="sm" pill v-if="!isVisualizar"
                    variant="success" @click="save">
                    <b-icon icon="check-circle" />
                    <b-tooltip :target="'salvarBaixaItemBemConsumo'" title="Salvar"></b-tooltip>
                </b-button>
                <b-button id="cancelarBaixaItemBemConsumo" class="my-2 ml-2" size="sm" pill variant="danger"
                    @click="cancelar">
                    <b-icon icon="x-circle" />
                    <b-tooltip :target="'cancelarBaixaItemBemConsumo'" title="Cancelar"></b-tooltip>
                </b-button>
            </b-col>
            <b-col cols="3"></b-col>
        </b-form-row>
        <ModalPageAlmoxarifadoItemBemConsumo :apenasSaldoPositivo="true"  v-if="showModalAlmoxarifado" :prefix="prefix"
            :title="'Itens do Almoxarifado'" @onselect="handleSelectAlmoxarifadoItem"
            @fecharModal="closeModalAlmoxarifado" />
        <BaixaItemBemConsumoEstornoForm v-if="showModalEstornoIndividual" :prefix="prefix"
            :title="'Cadastro > Estorno Baixa Item Bem Consumo'" :isIndividual="true" :id="idItemBemConsumoEstorno"
            :quantidade="quantidadeEstornoIndividual" @close="fecharModalEstornoIndividual" />

    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormTextarea from "@/core/components/Form/LgFormTextarea.vue";
import LgFinderPageTipoBaixa from "@/components/Finders/LgFinderPageTipoBaixa.vue";
import ModalPageAlmoxarifadoItemBemConsumo from "@/components/Finders/modalcompagina/almoxarifado/ModalPageAlmoxarifadoItemBemConsumo.vue";
import moment from "moment";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";

import { required } from "vuelidate/lib/validators";
import BaixaItemBemConsumoEstornoForm
    from "@/modules/almoxarifados/baixa-item-bem-consumo/BaixaItemBemConsumoEstornoForm.vue";

export default {
    name: "BaixaItemBemConsumoForm",
    components: {
        BaixaItemBemConsumoEstornoForm,
        ModalPageAlmoxarifadoItemBemConsumo,
        LgFinderPageTipoBaixa,
        LgFinderPagePessoa,
        LgFormDate,
        LgFormInput,
        LgFormTextarea,
    },
    props: {
        prefix: { type: String, default: "" },
        title: { type: String, default: "Cadastro" },
        id: { type: Number, default: null },
        isVisualizar: { type: Boolean, default: false }
    },

    mixins: [FormResourceMixin, ListResourceMixin],
    validations: {
        form: {
            responsavel: { required },
            data: { required },
            itens: { required },
            tipoBaixa: { required }
        }
    },
    data() {
        return {
            busy: false,
            form: {
                cod: null,
                data: null,
                horaEntrada: "",
                datacriacao: null,
                respcriacao: "",
                situacao: null,
                codtipobaixa: null,
                tipoBaixa: null,
                codstatus: null,
                motivoGeral: "",
                responsavel: null,
                itens: []
            },
            listaExclusao: [],
            showItens: false,
            showModal: true,
            motivoGeralChecked: false,
            showModalEstornoIndividual: false,
            idItemBemConsumoEstorno: null,
            quantidadeEstornoIndividual: null,
            tableItems: [],
            tableFields: [
                { key: "numero", label: "Número" },
                { key: "produto", label: "Produto" },
                { key: "almoxarifado", label: "Almoxarifado" },
                { key: "lote", label: "Lote" },
                { key: "motivoEspecifico", label: "Motivo Específico", thStyle: { minWidth: "200px" } },
                { key: "estoque", label: "Estoque" },

                { key: "quantidade", label: "Quantidade", thStyle: { minWidth: "120px"} },
                { key: "status", label: "Status" },
                { key: "acoes", label: " ", tdClass: "w-1" },
                { key: "estornar", label: " ", tdClass: "w-1" }
            ],
            savedId: this.id,
            showModalAlmoxarifado: false
        };
    },
    computed: {
        filteredItems() {
            return this.tableItems;
        }
    },
    async beforeMount() {
        this.$service = new ResourceService("/api/baixaitembemconsumo");
    },
    async mounted() {
        await this.load()
    },
    methods: {
        cancelar() {
            this.$emit("close");
        },
        handlePessoaSelect(item) {
            this.form.responsavel = item;
        },
        handleTipoBaixaSelect(tipo) {
            this.form.tipoBaixa = tipo;
        },
        handleMotivoGeral() {
            if (!this.motivoGeralChecked) {
                this.form.motivoGeral = "";
            }
        },
        async load() {
            if (this.id) {
                this.busy = true;
                const { data } = await this.$service.findById(this.id);
                this.busy = false;
                this.form.cod = data.cod;
                this.form.data = moment(data.data).format("YYYY-MM-DD");
                this.form.horaEntrada = moment(data.data).format("HH:mm");
                this.form.datacriacao = data.datacriacao;
                this.form.respcriacao = data.respcriacao;
                this.form.situacao = data.situacao;
                if (data.tipoBaixa) {
                    this.form.codtipobaixa = data.tipoBaixa.id;
                    this.form.tipoBaixa = data.tipoBaixa;
                }
                this.form.responsavel = data.pessoa;
                this.motivoGeralChecked = data.motivoGeral == 1;
                if (this.motivoGeralChecked &&
                    data.itemBemConsumoBaixaItemBemConsumo &&
                    Array.isArray(data.itemBemConsumoBaixaItemBemConsumo) &&
                    data.itemBemConsumoBaixaItemBemConsumo.length > 0) {
                    this.form.motivoGeral = data.itemBemConsumoBaixaItemBemConsumo[0].motivo || "";
                } else {
                    this.form.motivoGeral = "";
                }
                if (data.itemBemConsumoBaixaItemBemConsumo && Array.isArray(data.itemBemConsumoBaixaItemBemConsumo)) {
                    this.tableItems = data.itemBemConsumoBaixaItemBemConsumo.map(item => {
                        return {
                            itemBemConsumoItemId: item.id || null,
                            idSaldoAlmoxarifadoProduto: item.saldoAlmoxarifadoProduto.id,
                            numero: item.saldoAlmoxarifadoProduto.almoxarifadoProduto.produto.numero,
                            produto: item.saldoAlmoxarifadoProduto.almoxarifadoProduto.produto.descricaoResumida,
                            almoxarifado: item.saldoAlmoxarifadoProduto.almoxarifadoProduto.almoxarifado.descricao,
                            lote: item.saldoAlmoxarifadoProduto.lote ? item.saldoAlmoxarifadoProduto.lote.descricao : "",
                            estoque: item.saldoAlmoxarifadoProduto? item.saldoAlmoxarifadoProduto.saldo: "",
                            motivoEspecifico: item.motivo || "",
                            quantidade: item.quantidade,
                            status: item.status ? item.status.descricao : ""
                        };
                    });
                    this.form.itens = data.itemBemConsumoBaixaItemBemConsumo.map(item => {
                        return {
                            itemBemConsumoItemId: item.id || null,
                            idSaldoAlmoxarifadoProduto: item.saldoAlmoxarifadoProduto.id,
                            quantidade: item.quantidade
                        };
                    });
                }
            } else {
                this.form.situacao = 1;
            }
        },
        validateFormFields() {
            if (!this.form.responsavel || !this.form.responsavel.id) {
                this.$notify({
                    type: "danger",
                    message: "É necessário informar um responsável."
                });
                return false;
            }
            if (!this.form.tipoBaixa || !this.form.tipoBaixa.id) {
                this.$notify({
                    type: "danger",
                    message: "É necessário informar o tipo de baixa."
                });
                return false;
            }
            if (!this.form.data) {
                this.$notify({
                    type: "danger",
                    message: "É necessário informar uma data."
                });
                return false;
            }
            if (!this.tableItems || this.tableItems.length === 0) {
                this.$notify({
                    type: "danger",
                    message: "Selecione pelo menos um item."
                });
                return false;
            }
            return true;
        },
        async save() {
            if (!this.validateFormFields()) {
                return;
            }

            const itemComQuantidadeZero = this.tableItems.find(item => item.quantidade === 0);
            if (itemComQuantidadeZero) {
                this.$notify({
                    type: "danger",
                    message: "Não pode ter nenhum item com quantidade igual a 0."
                });
                return;
            }

            const itemComQuantidadeMaiorQueSaldo = this.tableItems.find(
                item => Number(item.quantidade) > Number(item.saldo)
            );
            if (itemComQuantidadeMaiorQueSaldo) {
                this.$notify({
                    type: "danger",
                    message: "A quantidade a dar baixa não pode ser maior que o saldo do produto."
                });
                return;
            }

            const dataCompleta = moment(
                `${this.form.data}T${this.form.horaEntrada}`,
                "YYYY-MM-DDTHH:mm"
            ).format("YYYY-MM-DDTHH:mm:ss");

            const payload = {
                data: dataCompleta,
                codtipobaixa: this.form.tipoBaixa ? this.form.tipoBaixa.id : null,
                pessoaId: this.form.responsavel ? this.form.responsavel.id : null,
                motivoGeral: this.motivoGeralChecked ? this.form.motivoGeral : "",
                itensBemConsumo: this.tableItems.map(item => {
                    if (this.form.id) {
                        return {
                            itemBemConsumoItemId: item.itemBemConsumoItemId,
                            idSaldoAlmoxarifadoProduto: item.idSaldoAlmoxarifadoProduto,
                            quantidade: item.quantidade,
                            motivoEspecifico: item.motivoEspecifico
                        };
                    } else {
                        return {
                            idSaldoAlmoxarifadoProduto: item.idSaldoAlmoxarifadoProduto,
                            quantidade: item.quantidade,
                            motivoEspecifico: item.motivoEspecifico ? item.motivoEspecifico : null
                        };
                    }
                })
            };

            if (this.form.id) {
                payload.id = this.form.cod;
                payload.cod = this.form.cod;
                payload.listaExclusao = this.listaExclusao || [];
            } else {
                payload.respcriacao = this.form.respcriacao;
            }

            this.busy = true;

            try {
                await this.$saveResource(payload, "", false, {}, false, true);

                this.busy = false;
                this.$emit("close");
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });
            } finally {
                this.busy = false;
                this.$emit("close");
            }
        },
        estornarIndividualmente(item) {
            this.idItemBemConsumoEstorno = item.itemBemConsumoItemId;
            this.quantidadeEstornoIndividual = item.quantidade;
            this.showModalEstornoIndividual = true;
        },
        fecharModalEstornoIndividual() {
            this.showModalEstornoIndividual = false;
            this.quantidadeEstornoIndividual = null
            this.idItemBemConsumoEstorno = null;
            this.load();
        },
        showModalAlmoxarifadoItem() {
            this.showModalAlmoxarifado = true;
        },
        handleSelectAlmoxarifadoItem(item) {

            if (item.saldo <= 0) {
                this.$notify({
                    type: "danger",
                    message: "Não é possível dar baixa em um item que não possui saldo."
                });
                return;
            }
            this.tableItems.push({
                itemBemConsumoItemId: null,
                idSaldoAlmoxarifadoProduto: item.idSaldoAlmoxarifadoProduto,
                numero: item.numeroProduto,
                produto: item.descricaoProduto,
                almoxarifado: item.almoxarifado,
                lote: item.lote,
                estoque: item.saldo,
                motivoEspecifico: "",
                quantidade: 0,
                status: ""
            });
            this.showModalAlmoxarifado = false;
        },
        closeModalAlmoxarifado() {
            this.showModalAlmoxarifado = false;
        },
        formatarHoraEntrada() {
            let valor = this.form.horaEntrada;
            valor = valor.replace(/[^0-9]/g, "");
            valor = valor.slice(0, 4);
            if (valor.length > 2) {
                valor = valor.slice(0, 2) + ":" + valor.slice(2);
            }
            this.form.horaEntrada = valor;
        },
        onlyNumbers(event) {
            const char = String.fromCharCode(event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },
    }
};
</script>

<style scoped></style>
